import { Dispatch, FC, SetStateAction } from 'react';
import { Multistep, useFieldApi, useFormState } from 'informed';
import { IYupSchema, STEPS, STEPS_ICONS, STEPS_LABELS, TimeStepValues, weekDayOptions } from '../../consts';
import InformedField from '../InformedField';
import Subtitle from '../Subtitle';
import Navigation from '../Navigation';
import { DateField } from '@components';
import { isSameOrAfter } from '@common/utils';
import { addMinutes, endOfDay, startOfDay, subMinutes } from 'date-fns';
import { DEFAULT_TIME_INTERVAL } from '@common/constants';
import CheckOptionField from '../CheckOptionField';
import comCss from '../../styles.module.scss';

interface ITimeStep {
  setYupSchema: Dispatch<SetStateAction<IYupSchema>>;
}

const DAY_START = startOfDay(new Date());
const DAY_END = endOfDay(new Date());

const DateStartTimeField = () => {
  const { getValue: getEndTimeValue, setValue: setEndTimeValue } = useFieldApi('end_time');

  const minTime = DAY_START;
  const maxTime = subMinutes(DAY_END, DEFAULT_TIME_INTERVAL);

  return (
    <DateField
      type='time'
      variant='dark'
      name='start_time'
      minTime={minTime}
      maxTime={maxTime}
      onChange={(date) => {
        const endTime = getEndTimeValue() as Date;

        if (date && (!endTime || isSameOrAfter(date, endTime))) {
          setEndTimeValue(addMinutes(date, DEFAULT_TIME_INTERVAL));
        }
      }}
    />
  );
};

const DateEndTimeField = () => {
  const { values } = useFormState();

  const startTimeValue = (values.time as TimeStepValues as any)?.start_time as Date;

  const minTime = startTimeValue ? addMinutes(startTimeValue, DEFAULT_TIME_INTERVAL) : DAY_START;

  const maxTime = DAY_END;

  return <DateField variant='dark' type='time' name='end_time' minTime={minTime} maxTime={maxTime} />;
};

const TimeStep: FC<ITimeStep> = ({ setYupSchema }) => {
  return (
    <Multistep.Step step={STEPS.TIME}>
      <Subtitle text={STEPS_LABELS.TIME} icon={STEPS_ICONS.TIME} />
      <div className={comCss.row}>
        <InformedField label='Start time'>
          <DateStartTimeField />
        </InformedField>
        <InformedField label='End time'>
          <DateEndTimeField />
        </InformedField>
      </div>
      <CheckOptionField name='weekdays' options={weekDayOptions} />
      <Navigation setYupSchema={setYupSchema} />
    </Multistep.Step>
  );
};

export default TimeStep;
